import { virtuosisInsance } from 'utils/axios';
import * as z from 'zod';

export const getAccount = async (ssoToken: string) => {
  const { data, status } = await virtuosisInsance.get(
    '/user-management/v1.0/account',
    {
      headers: { Authorization: ssoToken },
    },
  );

  if (status !== 200) {
    throw new Error(`/account call failed with status code ${status}`);
  }

  return data || {};
};

const AnalysisStateSchema = z.object({
  pending: z.array(z.string()),
});

type AnalysisState = z.infer<typeof AnalysisStateSchema>;

export const getAccountAnalysisState = async (ssoToken: string, signal?: AbortSignal): Promise<AnalysisState> => {
  const { data } = await virtuosisInsance.get(
    '/user-management/v1.0/account/analysis-state',
    {
      signal,
      headers: { Authorization: ssoToken },
    },
  ) || {};
  return AnalysisStateSchema.parse(data);
};
